export default __webpack_public_path__ + "static/media/ArrowHead.194d6054.svg";